const SIDEBAR_COLLAPSED_KEY = 'stockerai.sidebarCollapsed';

/**
 * Lee si la sidebar principal debe ir colapsada (cerrada).
 * Sin valor guardado: colapsada (primera visita / criterio por defecto).
 */
export function readSidebarCollapsed(): boolean {
  try {
    const raw = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
  } catch {
    /* ignore */
  }
  return true;
}

export function persistSidebarCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}
